import { SubscriptionCustomersTableV2CustomerFragment } from './__generated__/SubscriptionCustomersTable.graphql';

export enum Columns {
  Displays = 'displays',
  Name = 'name',
  Selection = 'selection',
  Subscription = 'subscription',
}

export type SelectableSubscriptionCustomersTableV2CustomerFragment =
  SubscriptionCustomersTableV2CustomerFragment & {
    isLinkedToSubscription?: boolean;
  };
